export default __webpack_public_path__ + "static/Propellant_(Scorched_Earth)-32cf9debdd671b0e487946365add6b2c.png";